import React from "react";
import { useRecoilValue } from "recoil";
import { Product } from "@components/Product";
import { getProducts } from "@helpers/api";
import "./style.css";
export const ProductList = () => {
    const products = useRecoilValue(getProducts);
    return (React.createElement("div", { className: "product-list" }, products.map(product => React.createElement(Product, { key: product.id, product: product }))));
};
